export default function HowItWorks() {
  const icon: any = <i className="bi bi-bookmark-star-fill beart-icon1"></i>;
  const caret: any = <i className="bi bi-caret-right-fill beart-icon1"></i>;

  return (
    <section className="beart-section flex flex-col rounded-md bg-amber-700 bg-opacity-15">
      <div
        className="background-attachment:fixed background-repeat:no-repeat background-size:cover background-position:center center relative z-0 hidden h-96 w-full"
        style={{
          backgroundImage: "url('/images/watercolor-bg-1.webp')",
          maskImage: "url('/images/mask/splatter-mask-1b.png')",
        }}
      ></div>
      <div className="relative z-10 bg-opacity-0">
        <h1 className="beart-title">Hogyan zajlik egy segítői beszélgetés?</h1>
        Általában heti vagy kétheti rendszerességgel. Az alkalmak 60 vagy 90
        percesek.
        <div className="mx-auto block w-3/4 justify-between md:flex">
          <div className="block md:flex-1">
            <h3 className="beart-subtitle">A leggyakoribb témák</h3>
            <ul className="zoom-fader mb-8 list-outside">
              <li className="flex">
                {icon}
                <div>önbizalom növelés</div>
              </li>
              <li className="flex">
                {icon}
                <div>kommunikáció fejlesztés</div>
              </li>
              <li className="flex">
                {icon}
                <div>stresszoldás, stresszkezelés</div>
              </li>
              <li className="flex">
                {icon}
                <div>kiégés megelőzés</div>
              </li>
              <li className="flex">
                {icon}
                <div>konfliktuskezelés</div>
              </li>
              <li className="flex">
                {icon}
                <div>karriermenedzsment</div>
              </li>
              <li className="flex">
                {icon}
                <div>önismeret fejlesztés</div>
              </li>
            </ul>
          </div>
          <div className="block md:flex-1">
            <h3 className="beart-subtitle">Milyen módszereket használok?</h3>
            <ul className="zoom-fader mb-8 list-outside">
              <li className="flex">
                {caret}
                <div>Művészetterápia</div>
              </li>
              <li className="flex">
                {caret}
                <div>Life és art coaching</div>
              </li>
              <li className="flex">
                {caret}
                <div>I-coaching módszere</div>
              </li>
              <li className="flex">
                {caret}
                <div>Preventív programok</div>
              </li>
              <li className="flex">
                {caret}
                <div>Család- és rendszerállítás</div>
              </li>
              <li className="flex">
                {caret}
                <div>Relaxációs technikák</div>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <strong>Segítői formák:</strong> egyéni és/vagy csoportos alkalmak
        </div>
        <div>
          <strong>Részvételi lehetőségek:</strong> személyesen vagy online
        </div>
      </div>
    </section>
  );
}
